import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ReplaceRoundQuestionsService {
  constructor() {}
  public isQuestionsReplaced: Subject<boolean> = new Subject();
}
